module.exports = __webpack_public_path__ + "7e48701a816e3c72fd0bc5c1f9659121.pdf";